import { render, staticRenderFns } from "./ck-content.vue?vue&type=template&id=1ce51de4&"
import script from "./ck-content.vue?vue&type=script&lang=js&"
export * from "./ck-content.vue?vue&type=script&lang=js&"
import style0 from "./ck-content.vue?vue&type=style&index=0&id=1ce51de4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports